import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './footer.css';

function Footer() {
    const location = useLocation();
    const hideFooterPaths = ['/signin', '/signup', "/live-exam", "/exam-result", '/allcreators', '/alltest', '/forgotpassword'];

    if (hideFooterPaths.includes(location.pathname)) {
        return null;
    }

    return (
        <div className="footer-wrapper">
            <footer className="site-footer">
                <div className="footer-top-wave"></div>

                <div className="footer-container">
                    {/* <div className="footer-brand">
                        <h2>Make My Exam</h2>
                        <p>Empowering learners and educators with quality test series</p>
                        <div className="footer-contact">
                            <span>📧 contact@makemyexam.com</span>
                            <span>📞 +91 9876543210</span>
                        </div>
                    </div> */}

                    <div className="footer-grid">
                        {/* Quick Links */}
                        <div className="footer-section">
                            <h3 className="footer-title">Quick Links</h3>
                            <ul className="footer-links">
                                <li><Link to="/" className="footer-link">🏠 Home</Link></li>
                                <li><Link to="/alltest" className="footer-link">📝 All Tests</Link></li>
                                <li><Link to="/allcreators" className="footer-link">👥 Top Creators</Link></li>
                            </ul>
                        </div>

                        {/* Test Series */}
                        <div className="footer-section">
                            <h3 className="footer-title">Popular Tests</h3>
                            <ul className="footer-links">
                                <li><Link to="/testseries/rrb" className="footer-link">🚆 RRB Test Series</Link></li>
                                <li><Link to="/testseries/ssc" className="footer-link">🎓 SSC Test Series</Link></li>
                                <li><Link to="/testseries/mpsc" className="footer-link">🏛️ MPSE Exams</Link></li>
                                {/* <li><Link to="/testseries/jee" className="footer-link">🔬 JEE  Entrance</Link></li> */}
                            </ul>
                        </div>

                        {/* Important Links */}
                        <div className="footer-section">
                            <h3 className="footer-title">Important Links</h3>
                            <ul className="footer-links">
                                <li><Link to="/aboutus" className="footer-link">ℹ️ About Us</Link></li>
                                <li><Link to="/terms-and-conditions" className="footer-link">📜 Term & Condition</Link></li>
                                <li><Link to="/contactus" className="footer-link">📬 Contact us</Link></li>
                            </ul>
                        </div>

                        {/* Newsletter */}
                        <div className="footer-section">
                            <h3 className="footer-title">Contact Us</h3>
                            <ul className="footer-links">
                                {/* <li className="footer-contact-item">
                                    <a href="mailto:myexamworld1@gmail.com" className="footer-link">
                                        Email: myexamworld1@gmail.com
                                    </a>
                                </li> */}
                                <li className="footer-links">
                                    <a href="https://www.facebook.com/myexamworld" className="footer-link">📘 Facebook</a>
                                    <a href="https://x.com/myexamworld" className="footer-link">🐦 Twitter</a>
                                    <a href="https://www.instagram.com/my_exam_world_" className="footer-link">📷 Instagram</a>
                                    {/* <a href="/" className="footer-link">LinkedIn</a> */}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <div className="copyright">
                            © {new Date().getFullYear()} My Exam World. All Rights Reserved.
                        </div>

                        {/* <div className="legal-links">
                            <Link to="/" className="legal-link">Privacy Policy</Link>
                            <Link to="/" className="legal-link">Terms of Service</Link>
                            <Link to="/" className="legal-link">Cookie Policy</Link>
                        </div> */}

                        {/* <div className="social-links">
                            <a href="/" className="social-link" aria-label="Facebook">📘</a>
                            <a href="/" className="social-link" aria-label="YouTube">📺</a>
                            <a href="/" className="social-link" aria-label="Twitter">🐦</a>
                            <a href="/" className="social-link" aria-label="Instagram">📷</a>
                            <a href="/" className="social-link" aria-label="LinkedIn">💼</a>
                        </div> */}
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;